/**
 * ProtectedRoute Component
 * Route guard for authenticated routes.
 */

import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * Route guard component that:
 * 1. Redirects unauthenticated users to login
 * 2. Redirects users with forcePasswordChange to change password page
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const forcePasswordChange = useAuthStore((state) => state.forcePasswordChange)
  const hadSession = useAuthStore((state) => state.hadSession)
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace {...(!hadSession && { state: { from: location } })} />
  }

  if (forcePasswordChange && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />
  }

  return <>{children}</>
}
